import React from "react";
import "./BlogPage.css";

function BlogPage() {
  return (
    <div className="main-content">
      <h1 className="home-title">Blog</h1>
      <div className="blog-posts">
        <div className="blog-post">
          <h2 className="blog-title">Io Sono: L’Eterno Potere del Sé</h2>
          <p className="blog-date">12 Gennaio 2025</p>
          <p className="blog-excerpt">
            Esplora il potere trasformativo del libro “Io Sono” e scopri come la tua connessione divina
            può cambiare la tua realtà.
          </p>
          <a href="/blog/io-sono" className="btn-read-more">
            Leggi di più
          </a>
        </div>
        <div className="blog-post">
          <h2 className="blog-title">Al Tuo Comando – Neville Goddard</h2>
          <p className="blog-date">13 Gennaio 2025</p>
          <p className="blog-excerpt">
            Scopri come Neville Goddard rivela il potere della coscienza e dell’immaginazione per creare
            la tua realtà.
          </p>
          <a href="/blog/al-tuo-comando" className="btn-read-more">
            Leggi di più
          </a>
        </div>
      </div>
    </div>
  );
}

export default BlogPage;